import { useContext } from 'react';
import { AuthContext } from '../../utils/contextapi/AuthProvider';
import { Navigate, useLocation } from 'react-router-dom';
import AdminDashboardPage from './AdminDashboard';
import ServiceDashboardPage from './ServiceDashboard';
import { getCookie } from '../../utils/cookies/cookies';

const DashboardRouter = ({ setMovePage }) => {
  const { isAuthenticated } = useContext(AuthContext);
  const location = useLocation();

  let role = [];
  try {
    const rolesStr = getCookie("roles");
    role = rolesStr ? JSON.parse(rolesStr) : [];
  } catch (e) {
    role = [];
  }

  // 인증 안된 경우 로그인 페이지로 이동
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // role이 없거나, 배열이 아닐 때 방어
  if (!role || !Array.isArray(role)) {
    return <Navigate to="/login" replace />;
  }

  const isServiceDashboard =
    location.pathname === '/service/dashboard' ||
    new URLSearchParams(location.search).get('view') === 'service_only';

  if (isServiceDashboard) {
    return <ServiceDashboardPage setMovePage={setMovePage} />;
  }

  if (role.includes("SYS_ADMIN")) {
    return <AdminDashboardPage setMovePage={setMovePage} />;
  }
  if (role.includes("SERVICE_ADMIN") || role.includes("USER")) {
    return <ServiceDashboardPage setMovePage={setMovePage} />;
  }

  // 권한이 없는 경우 로그인 페이지로 이동
  return <Navigate to="/login" replace />;
};

export default DashboardRouter;
